<template>
  <footer class="footer">
    <div class="container">
      <div class="level reverse-row">
        <div class="level-left">
          <router-link :to="{ name: 'About' }" class="navbar-item"
            >About</router-link
          >
          <router-link :to="{ name: 'Contact' }" class="navbar-item"
            >Contact</router-link
          >
        </div>
        <div class="level-right">
          <p class="navbar-item"><small>&copy;2018 Cicero Apps LLC</small></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>

<style lang="scss" scoped>
.footer {
  flex-shrink: 0;
}
.reverse-row {
  flex-direction: row-reverse;
}
</style>
